

































































import { Component, Vue } from "vue-property-decorator";
import { Shift } from "@/api";
import ShiftForm from "@/views/admin/shift/ShiftForm.vue";

@Component({
  components: { ShiftForm },
})
export default class ShiftDetail extends Vue {
  editDialog = false;
  confirmDelete = false;
  count = 0;

  get shiftId(): number {
    const shiftIdParam = this.$route.params.id as string;
    if (shiftIdParam) {
      try {
        return parseInt(shiftIdParam);
      } catch (e) {
        return 0;
      }
    }
    return 0;
  }

  get shift(): Shift | undefined {
    const shifts: Shift[] = this.$store.getters["shift/shifts"] || [];
    return shifts.find(s => s.id === this.shiftId);
  }

  async deleteShift() {
    this.confirmDelete = false;
    if (this.shiftId) {
      try {
        await this.$store.dispatch("shift/removeShift", this.shiftId);
        this.$router.push("/admin/shift");
      } catch (e) {
        console.error(e);
      }
    }
  }

  formatTime(time: string): string {
    if (!time) return "";
    if (time.includes("T")) {
      const date = new Date(time);
      return date.toLocaleTimeString([], {
        hour: "2-digit",
        minute: "2-digit",
      });
    }
    return time;
  }
}
